import { useEffect, useState } from 'react';
import { filterPendingTransactions } from '../utils';
import { calculateAmountTotal } from '../../credit-card-statements/utils';

export default function useTransactionFilter(mappedTransactions, initialShowPending = true) {
  const [showPending, setShowPending] = useState(initialShowPending);
  const [hideSubmitted, setHideSubmitted] = useState(false);
  const [displayedTransactions, setDisplayedTransactions] = useState([]);
  const [amountTotal, setAmountTotal] = useState(0);

  useEffect(() => {
    const source = Array.isArray(mappedTransactions) ? mappedTransactions : [];
    let filtered = filterPendingTransactions([...source], showPending);
    if (hideSubmitted) {
      filtered = filtered.filter(txn => !txn.raw_transaction.submitted);
    }
    setDisplayedTransactions(filtered);
    setAmountTotal(calculateAmountTotal(filtered));
  }, [mappedTransactions, showPending, hideSubmitted]);

  const handleShowPendingToggle = () => setShowPending((prev) => !prev);
  const handleHideSubmittedTransactionsToggle = () => setHideSubmitted((prev) => !prev);

  return {
    showPending,
    handleShowPendingToggle,
    hideSubmitted,
    handleHideSubmittedTransactionsToggle,
    displayedTransactions,
    amountTotal
  };
}
